import { createDocModalExecutor } from '@organisms/actions/createDocModalExecutor';
import { IRedirectExecutorProps } from './IRedirectExecutorProps';
import { RedirectExecutorModal } from './RedirectExecutorModal';

export const RedirectExecutor = createDocModalExecutor<IRedirectExecutorProps>({
    modal: RedirectExecutorModal,
    defaultModalSize: 'l',
    emptyElement: <div />,
    mapProps: ({ objId, action, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        docId: objId ?? '',
        actionKey: action.key ?? '',
        title: action.options?.title ?? '',
        message: action.options?.message ?? '',
        okButtonText,
        cancelButtonText,
        modalSize,
        completeHandler,
    }),
});
